import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FAQS } from "../data";

export const Faq = () => {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="section deep" data-testid="faq-section">
      <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.7 }}>
        <p className="eyebrow">Frequently asked questions</p>
        <h2 className="h2">Kaua'i property care,<br />answered.</h2>
        <p className="sub">Everything owners ask before booking — service area, pricing, guinea grass, off-island help and invoices.</p>
      </motion.div>
      <div className="faq-list">
        {FAQS.map((f, i) => {
          const isOpen = open === i;
          return (
            <div key={f.q} className={"faq-item" + (isOpen ? " is-open" : "")}>
              <button type="button" className="faq-q" onClick={() => setOpen(isOpen ? -1 : i)} aria-expanded={isOpen} data-testid={`faq-question-${i}`}>
                <span className="svc-num">{String(i + 1).padStart(2, "0")}</span>
                <span>{f.q}</span>
                <span className="svc-plus" aria-hidden="true">{isOpen ? "\u2212" : "+"}</span>
              </button>
              <AnimatePresence initial={false}>
                {isOpen && (
                  <motion.div
                    className="faq-a"
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.4, ease: [0.65, 0, 0.35, 1] }}
                  >
                    <p>{f.a}</p>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          );
        })}
      </div>
    </section>
  );
};
